import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import styles from './style.module.css';
import { Modal, Button } from 'react-bootstrap';
import { BreathAPIs } from '../APIs/BreathAPIs';
import { toast, ToastContainer } from 'react-toastify';
//import closeIcon from './images/close-icon.svg';
import { AiOutlineClose } from 'react-icons/ai';
import { VscDebugStart } from 'react-icons/vsc'
import { FaLocationDot, FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import { PiStopBold } from 'react-icons/pi'
import { CiPause1 } from 'react-icons/ci'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { addAmount } from '../Actions/Auth';
import { useDispatch } from 'react-redux';
import { useWebSocket } from '../Utils/WebSocketContext';
import ProgressBar from './components/ProgressBar';
import BillingBlock from './components/BillingBlock';
import { CiWarning } from "react-icons/ci";
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom';
import { IoInformationCircle } from "react-icons/io5";
import { Select, Modal as AntModal, Tooltip } from 'antd';
import SupportBlock from './components/SupportBlock/SupportBlock';
import { MdContactSupport } from "react-icons/md";
import StartEarlier from './components/StartEarlier';
import BookingExtension from './components/BookingExtension';
import { PiPlugChargingFill } from "react-icons/pi";
import StripePayment from '../StripePayment/StripePayment';
import { FaMoon } from 'react-icons/fa';
import Helper from '../Utils/Helper';

const PRICE_ENTRY_REGEX = /[\d.]+\s*kWh\s*@\s*\$[\d.]+\s*\/\s*kWh\s*\([^)]*\)/g;

function parsePriceBreakdownEntries(priceText) {
  if (!priceText) {
    return [];
  }
  const matches = priceText.match(PRICE_ENTRY_REGEX);
  const rawEntries = matches && matches.length > 0 ? matches : [priceText.trim()];
  return rawEntries
    .map((rawEntry) => {
      const trimmedLine = rawEntry.trim();
      const atIndex = trimmedLine.indexOf('@');
      if (atIndex === -1) {
        return { left: trimmedLine, time: '', right: '' };
      }
      const energyPart = trimmedLine.slice(0, atIndex).trim();
      let afterAt = trimmedLine.slice(atIndex + 1).trim();
      let parenPart = '';
      const parenIndex = afterAt.indexOf('(');
      if (parenIndex !== -1 && afterAt.endsWith(')')) {
        parenPart = afterAt.slice(parenIndex).trim();
        afterAt = afterAt.slice(0, parenIndex).trim();
      }
      return { left: energyPart, time: parenPart, right: afterAt };
    })
    .filter((entry) => entry.left || entry.right);
}

const Booking = forwardRef(({ title, chargerTag, chargerId, currentBookingID, startTime, endTime, isFuture, onCancel, connector, edrvID, jwt, bookingId, bookingType, freeChargingStartTime, freeChargingEndTime, userID, location, timeFormatAmPm, idleDuration, unUtilizedFee, unUtilizedTimeSec, transactionStatus, bookingStatusString, bookingSubmitFeedBack, nonReservable, createdAt, timeOfValidation, earlyAccess = false, booking = null, fetchData, endTimeScheduled, gracePeriod, estimateAmount, connectorNumber, breatheConnectorId, noOfConnectorsInCharger, walletAmount, isAutoPayEnabled, isNightCharging, nightChargeEndTime, isUserTester }, ref) => {

  const start = new Date(startTime);
  const end = new Date(isNightCharging ? nightChargeEndTime : endTime);
  const durationInMilliseconds = end - start;
  const durationInMinutes = durationInMilliseconds / (1000 * 60);

  const formattedStartTime = start.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm });
  const formattedEndTime = isNightCharging ? new Date(endTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm }) : end.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm });

  const locationName = location?.locationName;
  const locationCoordinates = location?.coordinates;

  const duration = `${formattedStartTime} - ${formattedEndTime}`;
  const [startChargeEnabled, setStartChargeEnabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isCharging, setIsCharging] = useState(false);
  const [isbookingCancelEnable, setIsbookingCancelEnable] = useState(false);
  const [isChargeCompleted, setIsChargeCompleted] = useState(false);
  const [bookingEnded, setBookingEnded] = useState(false)
  const [edrvSessionID, setEdrvSessionID] = useState('');
  const [count, setCount] = useState(0);
  const [isSubmittingStart, setIsSubmittingStart] = useState(false);
  const [isSubmittingStop, setIsSubmittingStop] = useState(false);
  const [isSubmittingPause, setIsSubmittingPause] = useState(false);
  const [isSessionCount, setIsSessionCount] = useState(true)
  const [noOfSessions, setNoOfSessions] = useState(0)
  const [bookingSessions, setBookingSessions] = useState([])
  const [sessionDuration, setSessionDuration] = useState(0)
  const [consumedEnergy, setConsumedEnergy] = useState(0)
  const [liveCost, setLiveCost] = useState(0)
  const [perkWhCost, setPerkWhCost] = useState(0)
  const [instantPower, setInstantPower] = useState(0)
  const [showStopConfirmation, setShowStopConfirmation] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [suspendedEVModal, setSuspendedEVModal] = useState(false);
  const [bookingEnergy, setBookingEnergy] = useState(0)
  const [bookingCost, setBookingCost] = useState(0)
  const [walletRechargeModal, setWalletRechargeModal] = useState(false)
  const [amountToAdd, setAmountToAdd] = useState(0)
  const [isEnergyLoading, setIsEnergyLoading] = useState(false)
  const [bookingStatusState, setBookingStatusState] = useState(bookingStatusString)
  // const [locationName, setLocationName] = useState('')

  const [connectorStatus, setConnectorStatus] = useState("");
  const [connectorNonReservable, setConnectorNonReservable] = useState(false);
  const [chargerStatus, setChargerStatus] = useState("")
  const [eventType, setEventType] = useState('')

  const [bookingStatus, setBookingStatus] = useState(null);


  const [energyReport, setEnergyReport] = useState([]);

  const [chargerAvailability, setChargerAvailability] = useState(true);

  const [hideSupport, setHideSupport] = useState(true);

  const [sessionHistoryExpanded, setSessionHistoryExpanded] = useState(false);

  const [idleElapsedSeconds, setIdleElapsedSeconds] = useState(0);

  const [transactionState, setTransactionState] = useState(transactionStatus)
  const [waiting, setWaiting] = useState(transactionState === "Accepted-Disable" ? true : false)
  const [newSelectedCharger, setNewSelectedCharger] = useState(null);

  const [lastSessionStartTime, setLastSessionStartTime] = useState(null);


  const dispatch = useDispatch();
  const webSocket = useWebSocket();

  const [countdown, setCountdown] = useState('');

  const [accessEarly, setAccessEarly] = useState(earlyAccess);

  const [showExtendButton, setShowExtendButton] = useState(false);

  const countdownInterval = useRef(null);

  const setShowExtendForUserMaxEnabledLoc = async () => {
    try{
      let chargerTime = Helper.convertToChargerTimeZone(new Date(startTime), location?.timezone) 
      let chargerTimeEnd = chargerTime
      let offSetBetweenChargerAndLocal = startTime ? new Date(startTime).getTime() - chargerTime.getTime() : 0
      let dayStart = chargerTime.setHours(0,0,0,0)
      let dayEnd = chargerTimeEnd.setHours(23, 59, 59, 999)
      dayStart = new Date(new Date(dayStart).getTime() + offSetBetweenChargerAndLocal)
      dayEnd = new Date(new Date(dayEnd).getTime() + offSetBetweenChargerAndLocal)
      let res = await BreathAPIs.getCurrentDayUserBookings(dayStart, dayEnd)
      // let maxAllowedDurationForLoc = selectedLocationData[0].maxChargeDuration * 60 * 60
      let usedSecByUser = res.data
      if(((location?.maxChargeDuration * 60 * 60) - usedSecByUser) >= 15 * 60){
        setShowExtendButton(true)
      }
      // let availableDuration = (Math.trunc((maxAllowedDurationForLoc - usedSecByUser)/15) * 15) / 3600
    }catch(err){
      console.log("error in setShowExtendForUserMaxEnabledLoc", err)
      setShowExtendButton(true)
    }
  }

  useEffect(() => {
    if(location){
      if(location?.userMaxDurationLimit == true){
        setShowExtendForUserMaxEnabledLoc()
      }else{
        let utiTime = (new Date(endTime) - new Date(startTime)) - (gracePeriod * 60 * 1000);
        if(((location?.maxChargeDuration * 60 * 60 * 1000) - utiTime) >= 15 * 60 * 1000){
          setShowExtendButton(true)
        }
      }
    }
  }, [location])

  useEffect(() => {
    if (nonReservable && transactionState !== "Accepted-Disable" && transactionState !== "Loading" && !isCharging && bookingStatus !== null) {
      const createdAtTime = bookingStatus === "rfid-authenticated" ? new Date(timeOfValidation) : new Date(createdAt);
      const countdownDuration = bookingStatus === "rfid-authenticated" ? 120 * 1000 : 120 * 1000;
      const endTime = new Date(createdAtTime.getTime() + countdownDuration);

      function updateCountdown() {
        const now = new Date();
        const timeRemaining = endTime - now;

        if (timeRemaining > 0) {
          const seconds = Math.floor((timeRemaining / 1000));
          setCountdown(`Expires in: ${seconds}s`);
        } else {
          clearInterval(countdownInterval.current);
          setCountdown("");
        }
      }
      // Clear any existing interval
      clearInterval(countdownInterval.current);
      countdownInterval.current = setInterval(updateCountdown, 500);
    } else {
      clearInterval(countdownInterval.current);
      setCountdown("");
    }
    // Clean up on unmount or when dependencies change
    return () => clearInterval(countdownInterval.current);
  }, [transactionState, isCharging, bookingStatus]);

  const idleInterval = useRef(null);
  useEffect(() => {

    if (bookingStatus === "Idle") {
      const graceEndTime = new Date(isNightCharging ? nightChargeEndTime : endTime).getTime();

      const updateIdleElapsed = () => {
        setIdleElapsedSeconds(Math.floor((Date.now() - graceEndTime) / 1000));
      };

      updateIdleElapsed();
      clearInterval(idleInterval.current);
      idleInterval.current = setInterval(updateIdleElapsed, 1000);
    } else {
      clearInterval(idleInterval.current);
    }

    return () => clearInterval(idleInterval.current);
  }, [bookingStatus, endTime]);

  const isWithinGracePeriod = idleElapsedSeconds < 0;
  const idleFeePerMin = location?.idleFee ? parseFloat(location.idleFee) : 0;
  const idleFeeAmount = isWithinGracePeriod ? 0 : (idleElapsedSeconds / 60) * idleFeePerMin;

  function formatIdleDuration(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return hours > 0 ? `${hours}h ${minutes}m ${seconds}s` : `${minutes}m ${seconds}s`;
  }

  useImperativeHandle(ref, () => ({
    refreshInProgressItems() {
      setRefresh(!refresh)
      setWaiting(transactionState === "Accepted-Disable" ? true : false)
    }
  }));

  const getMapURL = () => {
    if (locationCoordinates?.length == 2) {
      return `https://maps.google.com/maps?q=${locationCoordinates[1]},${locationCoordinates[0]}&hl=es`;
    }
    else {
      return '#';
    }

  }


  const addToTransactionHistory = async (amount, status, type) => {

    const res = await BreathAPIs.createTransactionHistory({
      dateEpoch: Math.floor(new Date().getTime() / 1000.0), // epoch value in GMT need to convert it into zone base 
      amount: amount,
      status: status,
      type: type
    })
  }




  const sessionCount = async () => {
    if (currentBookingID !== "") {

      const getBookingRes = await BreathAPIs.getBooking(bookingId)
      const sessionResponse = await BreathAPIs.getBookingSession(bookingId)
      setLastSessionStartTime(sessionResponse?.data[0]?.sessionStartTime ? new Date(sessionResponse?.data[0]?.sessionStartTime) : null)
      let transactionLength = getBookingRes.data.remoteTransactionStatus.length
      setIsCharging(getBookingRes.data.isSessionActive)
      setEdrvSessionID(getBookingRes.data.currentSessionEdrvID)
      setBookingEnded(getBookingRes.data.bookingEnded)

      // setBookingEnergy(getBookingRes.data.utilizedEnergy)
      // setConsumedEnergy(bookingEnergy)

      setNoOfSessions(getBookingRes.data.sessions.length)
      setBookingSessions(sessionResponse.data)
      setIsSessionCount(getBookingRes.data.sessions.length > 0 ? false : true)
      setBookingStatus(getBookingRes.data.bookingStatus);
      setTransactionState(getBookingRes.data.remoteTransactionStatus[transactionLength - 1])
      setBookingStatusState(getBookingRes.data.bookingStatus);
    }
  }


  const getCurrentCharger = async () => {
    if (chargerId !== null) {
      const currentCharger = await BreathAPIs.getCharger(chargerId)
      let connectorData = currentCharger.data.connector.filter((conn) => { return String(conn._id) === String(breatheConnectorId) })
      setConnectorStatus(connectorData[0].status)
      setConnectorNonReservable(connectorData[0].nonReservable)
      setChargerStatus(currentCharger.data.chargerStatus)
      setChargerAvailability(connectorData[0].connectorAvailability)
    }
  }

  const getEnergtReport = async () => {
    setIsEnergyLoading(true)
    const report = await BreathAPIs.getEnergtReport(bookingId)
    const getBookingRes = await BreathAPIs.getBooking(bookingId)
    setBookingEnergy(getBookingRes.data.utilizedEnergy)
    setBookingCost(getBookingRes.data.totalEnergyCostRaw)
    // setConsumedEnergy(bookingEnergy)
    setEnergyReport(report.data.energyReport)
    setConsumedEnergy(report.data.activeSession.activeSessionEnergy)
    setInstantPower(report.data.activeSession.activeSessionPower)
    setLiveCost(report.data.activeSession.liveCost)
    setIsEnergyLoading(false)
  }

  useEffect(() => {
    getCurrentCharger();
    if (title === "In-progress") {
      getEnergtReport()
    }

    if (webSocket) {
      webSocket.addEventListener('message', function (event) {
        setEventType(JSON.parse(event.data).type)             //charger diff 
        if (JSON.parse(event.data).type === "chargestation.connector_status.updated") { // Connector status Charging.
          for (let i = 0; i < JSON.parse(event.data).data.connectors.length; i++) {
            if (breatheConnectorId === JSON.parse(event.data).data.connectors[i].meta_data.breatheConnectorId) {
              setConnectorStatus(JSON.parse(event.data).data.connectors[i].status)
              if (JSON.parse(event.data).data.connectors[i].status === 'SuspendedEV') {
                setSuspendedEVModal(true)
              }
              if (JSON.parse(event.data).data.connectors[i].status !== 'SuspendedEV') {
                setSuspendedEVModal(false)
              }
            }
          }

        }
        if (JSON.parse(event.data).type === "suspendedEV_oneMin"){
          if(breatheConnectorId === JSON.parse(event.data).data.connectorId){
            setSuspendedEVModal(true)
          }    
        }
        if (JSON.parse(event.data).type === "chargestation.online") {
          if (chargerId === JSON.parse(event.data).data.connectors[0].rate.meta_data.breatheID) {
            setChargerStatus("Online")
          }
        }
        if (JSON.parse(event.data).type === "session.ended") {
          sessionCount()
        }
        if (JSON.parse(event.data).type === "session.started") {
          sessionCount()
          
          // let eventData = JSON.parse(event.data)
          // if (edrvSessionID === eventData.data._id) {
          //   setTransactionState("Accepted")
          // }
        }
        if (JSON.parse(event.data).type === "session.updated") {
        }
        if (JSON.parse(event.data).type === "session_update_event_broadcast") {
          let eventData = JSON.parse(event.data)
          // console.log("eventData session_update_event_broadcast", eventData)
          if (edrvSessionID === eventData.data.edrvSessionID) {
            // console.log("booking cost, booking energy", bookingCost, bookingEnergy)
            // console.log(bookingCost + eventData.data.liveCost, bookingEnergy + eventData.data.cumulativeEnergy)
            setConsumedEnergy(eventData.data.cumulativeEnergy)
            setInstantPower(eventData.data.power)
            setLiveCost(eventData.data.liveCost)
            setPerkWhCost(eventData.data.perkWhCost)
          }
        }
        if (JSON.parse(event.data).type === "chargestation.offline") {
          if (chargerId === JSON.parse(event.data).data.connectors[0].rate.meta_data.breatheID) {
            setChargerStatus("Offline")
          }
        }
        if (JSON.parse(event.data).type === "refetch_data") {
          setTimeout(() => {
            bookingSubmitFeedBack && bookingSubmitFeedBack();
          }, 1000);

        }


        // setData(event.data);  // Update state with received data
      });
    }


    sessionCount()
    setCount(count + 1)

    const checkTime = () => {
      const now = new Date();
      const future = new Date();
      future.setMinutes(now.getMinutes() + 1);
      if (start <= now) {
        setStartChargeEnabled(true);
        setAccessEarly(false)
      } else {
        setStartChargeEnabled(false);
        setAccessEarly(earlyAccess)
      }
    };
    checkTime();
    // Function to check if the start time is within the current time and current time + 7 minutes
    const timeUntilStart = start.getTime() - Date.now();
    //- (1 * 60 * 1000);
    const timeForEarlyAcces = start.getTime() - Date.now();
    // If start time is in the future, set up a timeout to enable charging
    //&& timeUntilStart <= 1*60*1000
    if (timeUntilStart > 0) {
      const timeoutId = setTimeout(() => {
        setStartChargeEnabled(true);
        setAccessEarly(false)
        fetchData()
      }, timeUntilStart);
      return () => { clearTimeout(timeoutId); }
    }
    else {
      checkTime();
      const intervalId = setInterval(checkTime, 60000);

      // Return cleanup function
      return () => { clearInterval(intervalId); };
    }


  }, [isCharging, bookingEnded, connectorStatus, chargerStatus, refresh, bookingEnergy, bookingCost]);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const handleConfirmCancel = () => {
    onCancel();
    handleCloseModal();
  };

  const handleStopModalClose = () => setShowStopConfirmation(false)
  const handleConfirmStop = () => {
    handleStop();
    handleStopModalClose();
  }

  const handleStart = async () => {
    try {
      const sessionDuration = (new Date(endTime) - new Date()) / (1000 * 60) // session duration in minutes.

      countdownInterval && clearInterval(countdownInterval);

      setIsSubmittingStart(true)
      setTransactionState("Loading")
      const session = {
        connector: connector,
        userEDRV: edrvID,
        target: { time: sessionDuration },
        bookingID: bookingId,
        startActionCreatedAt: new Date()
      }

      const result = await BreathAPIs.startSession(jwt, session)

      // setTransactionState(result.data)
      // let transactionLength = result.data.transactionState.length
      // setTransactionState(result.data.transactionState[transactionLength-1])

      if (result.data.message === "Session Started") {
        setTransactionState("Accepted-Disable")
        toast.success('Session Started.')
        setEdrvSessionID(result.data.session.edrvSessionID)
        setIsCharging(true);
        setIsbookingCancelEnable(true)

      }
      if (result.data.message === "session start error") {
        toast.warning("Error in starting session, unplug and replug")
      }
      if (result.data.message === "server error") {
        toast.error("Couldn't start session try reconnecting charger.")
      }
      if (result.data.message === 'Suspended EV') {
        setSuspendedEVModal(true);
      }

    } catch (error) {
      toast.error("error starting session.")
      setTransactionState("Rejected")
    }
    setIsSubmittingStart(false)
  }

  const handleStop = async () => {
    try {
      setIsSubmittingStop(true)
      // if(isCharging){
      //   await handlePause(true)
      // }

      const stopActionCreatedAt = new Date()

      const res = await BreathAPIs.endBooking(bookingId, userID, stopActionCreatedAt)
      if (res.data.message === "Booking Ended.") {
        setIsCharging(false);
        setIsSubmittingStop(false);
        setBookingEnded(true);
        toast.success("Booking Ended Successfully.")
      }

      if (res.data.message === "Error in booking stop.") {
        setIsSubmittingStop(false)
        toast.error("Something went wrong while try to end the booking.")
      }
      if (res.data.message === "Booking Already Stopped") {
        setIsCharging(false);
        setIsSubmittingStop(false);
        setBookingEnded(true);
        toast.warning("Booking Already Stopped.")
      }
    } catch (error) {

    }

  }

  const handlePause = async (isStopClicked = false) => {
    try {
      isStopClicked === true ? setIsSubmittingPause(false) : setIsSubmittingPause(true)
      const pauseActionCreatedAt = new Date()
      const res = await BreathAPIs.stopSession(edrvSessionID, pauseActionCreatedAt)

      if (res.data.message === 'Session stopped') {
        setIsCharging(false);
        setIsChargeCompleted(true);
        setBookingEnded(false);
        if (!isStopClicked) {
          toast.success("Session Paused.")
        }

      }

      if (res.data.message === 'stop session api error') {
        toast.error("Error stopping session. ")
      }

      if (res.data.message === 'No Active session') {
        toast.warning("No active session to stop.")
        setIsCharging(false)
      }

    } catch (error) {

    }
    setIsSubmittingPause(false)
  }

  const [isWithinFifteenMinutes, setIsWithinFifteenMinutes] = useState(false);

  const handleAddAmount = () => {
    const difference = estimateAmount - walletAmount;
    // Ensure we are working with numbers for the comparison
    const amountToSet = difference < 10 ? 10 : Math.ceil(difference);

    setAmountToAdd(amountToSet);
    setWalletRechargeModal(true);
  };
  // useEffect(() => {
  //   const checkTime = () => {
  //     const now = new Date();
  //     const start = new Date(startTime);
  //     const timeDifference = (start - now) / (1000 * 60);

  //     setIsWithinFifteenMinutes(timeDifference <= 15 && timeDifference >= 0);
  //   };

  //   checkTime();
  //   const interval = setInterval(checkTime, 60000);

  //   return () => clearInterval(interval);
  // }, [startTime]);




  if (isFuture) {
    const startButtonDisabled = bookingStatus === 'rfid-authenticated' || (((connectorStatus === "Preparing" || connectorStatus === "Finishing") && chargerStatus === "Online" && (chargerAvailability === true || isUserTester) ) ? false : true) || (!startChargeEnabled || isCharging || bookingEnded || isSubmittingStart || isSubmittingPause || isSubmittingStop) || connectorStatus === "SuspendedEV" || (isSessionCount === true && connectorStatus === 'Finishing') || (transactionState === "Accepted-Disable") || (transactionState === "Rejected-Disabled") || (transactionState === "Loading");
    const stopButtonDisabled = (!isCharging && isSessionCount) || bookingEnded || isSubmittingPause || isSubmittingStop || isSubmittingStart || (chargerStatus === "Offline" ? true : false) || connectorStatus === "SuspendedEV" || transactionState === "Accepted-Disable" || (transactionState === "Loading");
    const pauseButtonDisabled = !isCharging || bookingEnded || isSubmittingPause || isSubmittingStop || isSubmittingStart || ((connectorStatus !== "Charging") ? true : false) || (chargerStatus === "Offline" ? true : false) || connectorStatus === "SuspendedEV" || transactionState === "Accepted-Disable" || (transactionState === "Loading");
    const cancellationButtonDisabled = nonReservable || isCharging || !isSessionCount || bookingEnded || isSubmittingPause || isSubmittingStop || isSubmittingStart || transactionState === "Accepted-Disable" || (transactionState === "Loading")

    
    setTimeout(() => {
      setWaiting(transactionState === "Accepted-Disable" ? true : false)
    }, 10000)
    return (
      <div className={`card ${styles['booking-card']} ${(connectorStatus === "Charging") && styles['active']}`}>
        {connectorStatus === "SuspendedEV" ?
          <div className={`${styles['suspended-Ev-banner']}`} role="alert">
            
            <CiWarning />
            {((lastSessionStartTime !== null ?  ((new Date() - lastSessionStartTime) > 1*60*1000) : ((new Date() - new Date(startTime)) > 1*60*1000)) || eventType === "suspendedEV_oneMin")? "Car is not accepting charge. Please try reconnecting the charger." :
            "Waiting for vehicle, please wait for a minute."}
          </div> :
          <></>}
        
        {/* {((connectorStatus === "Available" && isSessionCount) && !(waiting && transactionState === "Accepted-Disable")) ?
          <div className={`connect-charger-banner-div`}><span className={`${styles['connect-charger-banner']}`} role="alert">
            
            Please ensure to connect vehicle to the correct charger.
          </span> </div>:
          <></>} */}

        {
          ((connectorStatus === 'Available' && isSessionCount && chargerStatus === 'Online')
            &&
            <div className={`connect-charger-banner-div`}><span className={`${styles['start-waiting-banner']}`}>

              Press <b style={{ padding: '0 2px' }}> refresh </b> once plugged-in to vehicle.
            </span> </div>
          )
        }
        {
          (waiting && transactionState === "Accepted-Disable") ?
            <div className={`${styles['start-waiting-banner']}`} role="success">
              We appreciate your patience. Collecting energy data from the charger...
            </div>
            :
            <></>
        }
        {
          (transactionState === "Rejected-Disabled") ?
            <div className={`${styles['start-waiting-banner']}`} role="success"> 
              Please <b style={{ padding: '0 2px' }}> plug-in </b> your vehicle to start charging.
            
            </div>
            :
            <></>
        }

        <div className="">
          <div className="card-body" style={{ paddingTop: '0.5rem' }}>

          <div className={`${styles['flex-container']}`}> 
            <div>
              <div className={`${styles['animation-cost-container']}`}>
              {isCharging && (connectorStatus === "Charging" && chargerStatus === "Online") &&
                <>
                <div><FontAwesomeIcon icon={faBolt} className={`${styles.chargingAnimation} ${styles.iconSpacing}`} /></div>
                <div className={styles['booking-cost']}>
                  {isEnergyLoading ? "-.-" : (bookingType === 'free' ? 'Free Charge' : (perkWhCost ? "$ " + parseFloat(perkWhCost).toFixed(2) + "/kWh" : '-.-/kWh'))} 
                </div>
              </>
              }
              </div>
              <div className={styles['flex-container']}><div className={styles['booking-day-month-year']}>
                {start.toLocaleString('default', { month: 'short' })} {start.getDate()}, {start.getFullYear()}
                {isNightCharging && <FaMoon color='#e09839ff'> </FaMoon>}
              </div>
              
              {(nonReservable && countdown) && (bookingStatus === 'rfid-authenticated' || bookingStatus === 'Upcoming') && //title !== 'Upcoming Booking' &&
                <div className={styles["card-top-right-countdown"]}>{countdown}</div>
              }</div>
              {isNightCharging && <div>
                <p className={styles['booking-tile-night-charge-text']} >Overnight Booking</p>
              </div>}
            </div>

              <div className={styles["card-top-right"]}>


                { (((bookingStatusState === "Upcoming" && booking?.nonReservable === false) || bookingStatusState === "Inprogress" ) && showExtendButton) &&
                  <div style={(!startChargeEnabled || !cancellationButtonDisabled) ? { marginRight: '5px' } : {}}>
                    <BookingExtension

                      chargerAvailability={chargerAvailability}
                      booking={booking}
                      updateTrigger={() => { bookingSubmitFeedBack && bookingSubmitFeedBack(); }}
                      location={location}

                    />
                  </div>
                }


                {(!startChargeEnabled || !cancellationButtonDisabled) && (
                  <button
                    className={`btn btn-danger ${styles.roundedButton} ${styles.right}`}
                    onClick={handleShowModal}>
                    <AiOutlineClose size={24} />
                  </button>
                )}




                {/* {title === 'In-progress' &&<Tooltip color={('#50B965')} placement="top" title={'Report an issue'} >
                <button className={`${styles['show-support-button']} ${!hideSupport ? styles['active'] : ''}`} onClick={() => setHideSupport(!hideSupport)}><MdContactSupport /></button>
              </Tooltip>} */}
              </div>
            </div>

            <div className={styles['booking-durations']}>

              {(title === 'In-progress' && (connectorStatus === 'Charging' || connectorStatus === 'Preparing' || connectorStatus === 'Available' || connectorStatus === 'Finishing')) ?
                <div className={styles['progress-container']}>
                  <ProgressBar startTime={start} endTimeWithGrace={end} energyReport={energyReport} timeFormatAmPm={timeFormatAmPm} connectorStatus={connectorStatus} bookingStatus={bookingStatus} endTimeScheduled={endTimeScheduled} gracePeriod={gracePeriod} isNightCharging={isNightCharging} bookingEndTime={endTime} />
                </div> :
                <span className={styles['booking-duration']}>
                  {duration}
                </span>
                
              }
              
            </div>
            {isNightCharging && title !== 'In-progress' && <div className={styles['booking-night-charging']}><p>No idle fee until 9 AM</p></div>} 

          </div>
        </div>

        <>
          {title === 'In-progress' &&
            <>
              <div className={`${styles['card-bottom-online-bar']} ${(connectorStatus === "Charging" && chargerStatus === "Online") ? styles['online'] : styles['offline']}`}>
                {chargerStatus === "Offline" ?
                  <div className={styles['badge']}>Charger Offline</div>
                :
                  <div className={styles['badge']}>{connectorStatus === "Charging" ? 'Charging' : 'Not Charging'}</div>
                }
              </div>
              <div className={`${styles['card-bottom-live-bar']}`}>
                {bookingStatus === "Idle" ? (
                  isWithinGracePeriod ? (
                    <div className={styles['live-stat-message']}>You will accrue Idle Fee after grace period ends</div>
                  ) : (
                    <>
                      <div className={styles['live-stat']}>
                        <span className={styles['live-stat-label']}>Idle Time</span>
                        <span className={styles['live-stat-value']}>{formatIdleDuration(idleElapsedSeconds)}</span>
                      </div>
                      <div className={`${styles['live-stat']} ${styles['pull-right']}`}>
                        <span className={styles['live-stat-label']}>Idle Fee</span>
                        <span className={styles['live-stat-value']}>$ { bookingType !== 'paid' ? "0.00" : idleFeeAmount.toFixed(2)}</span>
                      </div>
                    </>
                  )
                ) : (
                  <>
                    <div className={styles['live-stat']}>
                      <span className={styles['live-stat-label']}>Power</span>
                      <span className={styles['live-stat-value']}>{instantPower ? parseFloat(instantPower).toFixed(2) : '0.00'}<span className={styles['live-stat-unit']}> kW</span></span>
                    </div>
                    <div className={`${styles['live-stat']} ${styles['margin-left']}`}>
                      <span className={styles['live-stat-label']}>Energy</span>
                      <span className={styles['live-stat-value']}>{isEnergyLoading ? "-.-" : (consumedEnergy ? parseFloat(consumedEnergy).toFixed(4) : '0.0000')}<span className={styles['live-stat-unit']}> kWh</span></span>
                    </div>
                    <div className={`${styles['live-stat']} ${styles['pull-right']}`}>
                      <span className={styles['live-stat-label']}>Energy Cost</span>
                      <span className={styles['live-stat-value']}>{isEnergyLoading ? "-.-" : (bookingType === 'free' ? '$ 0.00' : (liveCost ? "$ " + parseFloat(liveCost).toFixed(2) : '$ 0.00'))}</span>
                    </div>
                  </>
                )}
              </div>
            </>
          }


          <div className={`${styles['card-bottom']} ${(title === "In-progress" && (connectorStatus === "Available" || connectorStatus === "Preparing" || connectorStatus === "Finishing") && bookingStatus !== "Idle") ? styles['bottom-banner-fixed'] : ''}`}>
            {/* {(title !== 'In-progress' || (title === 'In-progress' && ((chargerAvailability === true && hideSupport) || !isSessionCount))) ? */}

            {(title !== 'In-progress' || (title === 'In-progress' && ((hideSupport)))) ?
              <>
                {title !== 'Upcoming Booking' ?

                  ((booking?.autoPayFlag === true) && (estimateAmount > walletAmount) && (isAutoPayEnabled === false)) ?
                    <>
                      <div className={`${styles['auto-pay-warning-container']}`}>
                        <span className={`${styles['auto-pay-warning-title']}`} onClick={() => { handleAddAmount() }}>
                          Add Amount
                        </span>
                        <div className={`${styles['auto-pay-warning-content']}`}>
                          Please add
                          <span className={`${styles['auto-pay-warning-amount']}`}> ${(estimateAmount - walletAmount) < 10 ? 10 : Math.ceil(estimateAmount - walletAmount)} </span>
                          to your wallet to proceed charging.
                        </div>
                      </div>

                    </>
                    :
                    <>
                      <button
                        className={`btn btn-success ${styles.roundedButton} ${!startButtonDisabled ? styles.startPulse : ''} ${isCharging ? styles.charging : ''}`}
                        disabled={startButtonDisabled}    //preparing false
                        onClick={handleStart}>

                        {(isSubmittingStart || transactionState === "Loading" ? true : false) && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                        {!(isSubmittingStart || transactionState === "Loading" ? true : false) && <VscDebugStart className={styles.iconButton}></VscDebugStart>}
                      </button>
                      {!(isSessionCount && transactionState === "Accepted") && <button
                        className={`btn btn-danger ${styles.roundedButton}`}
                        disabled={stopButtonDisabled}
                        onClick={() => setShowStopConfirmation(true)}>
                        {/* ⏹️ */}
                        {isSubmittingStop && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                        {!isSubmittingStop && <PiStopBold className={styles.iconButton}></PiStopBold>}
                      </button>}
                      {!nonReservable && !(isSessionCount && transactionState === "Accepted") && <button
                        className={`btn btn-warning ${styles.roundedButton}`}
                        disabled={pauseButtonDisabled}
                        onClick={() => handlePause(false)}

                      >
                        {/* ⏹️ */}
                        {isSubmittingPause && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                        {!isSubmittingPause && <CiPause1 className={styles.iconButton}></CiPause1>}
                      </button>}

                      <div className={`${styles['card-bottom-right']}`}>
                        <div className={styles['with-support']}>
                          <a target='_blank' href={getMapURL()} >
                            <div className={`${styles['main']}`}>
                              {chargerTag} {noOfConnectorsInCharger !== 1 ? ` - #${connectorNumber}` : ""}
                              {/* <PiPlugChargingFill /> */}
                            </div>
                            <div className={`${styles['sub']}`}>
                              <FaLocationDot />{locationName}
                            </div>
                          </a>
                          {/* <Tooltip color={('#50B965')} placement="top" title={'Report an issue'} >
                        <button onClick={() => setHideSupport(!hideSupport)}><MdContactSupport /></button>
                      </Tooltip> */}
                        </div>
                      </div>
                    </>

                  :

                  <>

                    {/* {chargerAvailability === false && !isWithinFifteenMinutes
                    ? */}
                    {accessEarly && <StartEarlier
                      chargerAvailability={chargerAvailability}
                      booking={booking}
                      updateTrigger={() => { bookingSubmitFeedBack && bookingSubmitFeedBack(); }}
                      location={location}
                    />}

                    <div className={`${styles['card-bottom-right']}`}>
                      <a target='_blank' href={getMapURL()} >
                        <div className={`${styles['main']}`}>
                          {chargerTag} {noOfConnectorsInCharger !== 1 ? ` - #${connectorNumber}` : ""}
                          {/* <PiPlugChargingFill /> */}
                        </div>
                        <div className={`${styles['sub']}`}>
                          <FaLocationDot />{locationName}
                        </div>
                      </a>
                    </div>
                    {/* // } */}

                  </>}

              </>
              :
              <SupportBlock
                cancelAction={chargerAvailability ? () => setHideSupport(!hideSupport) : undefined}
                bookingId={bookingId}
                bookingEndTime={end}
                location={location}
                chargerTag={chargerTag}
                supportText={chargerAvailability ? 'Facing an Issue?' : 'Facing an Issue?'}
                buttonText={chargerAvailability ? 'Report' : 'Report'}
                showingReportIssue={(title !== 'In-progress' || (title === 'In-progress' && ((hideSupport) || !isSessionCount))) ? false : true}
                issueSubmittedFeedback={() => { bookingSubmitFeedBack && bookingSubmitFeedBack(); }}
                timeFormatAmPm={timeFormatAmPm}
                type={chargerAvailability ? 'other' : 'charger-offline'}
                isCharging={isCharging}
                isSessionCount={!isSessionCount}
                connectorNumber={connectorNumber}
                breatheConnectorId={breatheConnectorId}
                connectorStatus={connectorStatus}
                bookingNonRes={connectorNonReservable}
                noOfConnectorsInCharger={noOfConnectorsInCharger}
                isNightCharging = {isNightCharging}
                bookingStartTime = {start}
                nightChargeEndTime = {nightChargeEndTime}

              // isSessionCount={isSessionCount}
              // isCharging={isCharging}
              // connectorStatus={connectorStatus}
              // chargerStatus={chargerStatus}
              // bookingStatus={bookingStatus}
              // edrvID={edrvID}
              // jwt={jwt}
              // userID={userID}
              // bookingType={bookingType}
              // isSessionCount={true}
              // type={'charger-offline'}
              />
            }
          

          </div>
          {(title === "In-progress") &&
          <>
          {/* {console.log("isEnergyLoading",isEnergyLoading)} */}
          <div>
            { (bookingEnded && bookingStatus === "Idle") ? (
              <div className={styles['session-totals-block']}>
                <div className={styles['session-history-stat']}>
                  <span className={styles['session-history-stat-label']}>Total Energy</span>
                  <span className={styles['session-history-stat-value']}>{bookingEnergy ? parseFloat(bookingEnergy).toFixed(4) : '0.0000'} kWh</span>
                </div>
                <div className={`${styles['session-history-stat']} ${styles['pull-right']}`}>
                  <span className={styles['session-history-stat-label']}>Total Energy Cost</span>
                  <span className={styles['session-history-stat-value']}>$ {bookingType !== 'paid' ? "0.00" : (bookingCost ? parseFloat(bookingCost).toFixed(2) : '0.00')}</span>
                </div>
              </div>
            ) : <></> }
            {noOfSessions > 0 && (() => {
              // {console.log("Booking sessions",bookingSessions)}
              const sessionsToShow = bookingSessions.filter((session) => (session.sessionEndTime !== null && session.sessionEndTime !== undefined));
              // !isCharging ? bookingSessions : bookingSessions.filter((session) => (session.edrvSessionID !== edrvSessionID));
              return sessionsToShow.length > 0 && (
                <div className={styles['session-history-block']}>
                  <button
                    type="button"
                    onClick={() => setSessionHistoryExpanded(!sessionHistoryExpanded)}
                    className={styles['session-history-toggle']}
                  >
                    {sessionHistoryExpanded ? <FiMinus /> : <FaPlus />} Sessions ({sessionsToShow.length})
                  </button>
                  {sessionHistoryExpanded && (
                    <div className={styles['session-history-table-wrap']}>
                      <table className={styles['session-history-table']}>
                        <thead>
                          <tr>
                            <th>Session</th>
                            <th>Peak Power</th>
                            <th>Energy</th>
                            {/* <th>Rate Breakdown</th> */}
                            <th>Energy Cost</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sessionsToShow.map((session, index) => (
                            <tr key={session._id || index}>
                              <td>S{index + 1}</td>
                              <td>{session.peakPower ? parseFloat(session.peakPower).toFixed(2) : '0.00'} kW</td>
                              <td>{(session.averageQuantityPerSec * session.sessionDurationInSeconds).toFixed(4)}</td>
                              {/* <td className={styles['session-rate-cell']}>
                                {parsePriceBreakdownEntries(session.priceText).map((entry, idx) => (
                                  <div key={idx} className={styles['session-rate-line']}>
                                    <span>{entry.left}</span>
                                    {entry.right && <span> @ {entry.right}</span>}
                                    {entry.time && <span className={styles['session-rate-time']}> {entry.time}</span>}
                                  </div>
                                ))}
                              </td> */}
                              <td>$ { bookingType !== 'paid' ? "0.00" : (session.liveCost ? parseFloat(session.liveCost).toFixed(2) : '0.00')}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              );
            })()}
            

          </div>
            {bookingStatus !== "Idle" &&
            <div className={`${styles['bottom-banner']}`}>
              {(bookingStatus !== "Idle" && chargerStatus === "Online") && connectorStatus === "Available" &&
                <span><IoInformationCircle /> Plug-in <b>{chargerTag}</b> to your vehicle</span>}
              {(bookingStatus !== "Idle" && chargerStatus === "Online") && (connectorStatus === "Preparing" || connectorStatus === "Finishing") && bookingStatus !== "rfid-authenticated" &&
                <span className={`${styles['bottom-banner']}`}>
                  <IoInformationCircle /> Press <VscDebugStart /> to start charge
                </span>
              }
              {(bookingStatus === "rfid-authenticated" && chargerStatus === "Online") && connectorStatus === "Preparing" &&
                <span><IoInformationCircle />Plug-in the connector to start charge</span>}

              {(!isCharging || (isCharging && chargerStatus === "Offline") || connectorStatus === "Faulted") && bookingStatus !== "Idle" && <button onClick={async ()  => {await getCurrentCharger(); setHideSupport(!hideSupport)}} className={`${styles['show-support-btn-bottom']} ${hideSupport ? styles['active'] : ''}`}>Need help?</button>}</div>
            }
          </>
          }
          {/* {(title === "In-progress" && bookingStatus !== "Idle" && chargerStatus === "Online") &&
            (connectorStatus === "Preparing" || connectorStatus === "Finishing") &&
            <div className={`${styles['bottom-banner']}`}>
              <IoInformationCircle /> Press <VscDebugStart /> to start charge
            </div>
          } */}
        </>

        {walletRechargeModal && <AntModal open={walletRechargeModal} onCancel={() => { setWalletRechargeModal(!walletRechargeModal) }} footer={null}>
          <StripePayment setWalletRechargeModal={setWalletRechargeModal} amountToAdd={amountToAdd} />
        </AntModal>}

        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to cancel booking?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={handleConfirmCancel}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStopConfirmation} onHide={handleStopModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to stop booking?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleStopModalClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleConfirmStop}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>


      </div>
    );
  }

  else {
    return (
      <div className={`card ${styles['booking-card']} ${bookingStatusString === 'TicketClosed' ? styles['ticket-closed'] : ''}`}>
        <div className="">
          <div className="card-body">
            <div>
              <span className={styles["card-title-two-rows"]}>
                <a target='_blank' href={getMapURL()} >
                  <div className={styles["main"]}>{chargerTag} {noOfConnectorsInCharger !== 1 ? ` - #${connectorNumber}` : ""}</div>
                  {/* <PiPlugChargingFill /> */}
                  <div className={`${styles['sub']}`}>
                    <FaLocationDot />{locationName}
                  </div>
                </a>
              </span>
            </div>
            <div className={styles["card-top-right"]}>
              <div className={styles['booking-month-year']}>
                {start.toLocaleString('default', { month: 'short' })} {start.getDate()}, {start.getFullYear()}
              </div>
            </div>

            <div className={styles['booking-durations']}>
              <span className={styles['booking-duration']}>
                {duration}
              </span>
              
            </div>
            {bookingStatusString !== 'TicketClosed' && <BillingBlock bookingId={bookingId} idleDuration={idleDuration ? idleDuration : 0} unUtilizedFee={unUtilizedFee ? unUtilizedFee : 0} unUtilizedTimeSec={unUtilizedTimeSec ? unUtilizedTimeSec : 0} nonReservable={nonReservable} estimateAmount={estimateAmount} timeFormatAmPm={timeFormatAmPm} />}
          </div>
        </div>
      </div>
    );
  }



});

export default Booking;